import { NgModule } from '@angular/core';
import { BaseStorefrontModule } from '@spartacus/storefront';
import { CustomProdPgModule } from '../custom-prod-pg/custom-prod-pg.module';
import { SpartacusConfigurationModule } from './spartacus-configuration.module';
import { SpartacusFeaturesModule } from './spartacus-features.module';

@NgModule({
  declarations: [],
  imports: [
    BaseStorefrontModule,
    SpartacusFeaturesModule,
    SpartacusConfigurationModule,
    CustomProdPgModule,
  ],
  exports: [BaseStorefrontModule],
})
export class SpartacusModule {}
